<script setup lang="ts">
  defineProps({
    loading: { type: Boolean, required: false, default: true },
  });
</script>
<template>
  <template v-if="loading">
    <div class="data-loader">
      <SfSpinner primary large />
      <p>{{ $t('Trwa wczytywanie danych...') }}</p>
    </div>
  </template>
  <template v-else>
    <slot />
  </template>
</template>
<style lang="scss">
  .data-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    width: 100%;
    padding: 2rem;
  }
</style>
